import React from "react";
import { Skeleton } from "@/v2-components/ui/skeleton";
import { cn } from "@/libs/utils";

const BlogSkeletonCard = ({
  className,
  count = 4,
}: {
  className?: string;
  count?: number;
}) => {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-7 laptop:grid-cols-4 laptop:gap-6",
        className,
      )}
    >
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
  );
};

export default BlogSkeletonCard;

const SkeletonCard = () => {
  return (
    <div className="w-full">
      <div className="relative aspect-[342/192] w-full overflow-hidden rounded-lg bg-coolgray-20">
        <Skeleton className="absolute inset-0 h-full w-full rounded-lg bg-coolgray-20" />
      </div>
      <Skeleton className="mt-4 h-6 w-3/4 rounded-md bg-coolgray-20" />
    </div>
  );
};
